export const mesIconMap: Record<string, string> = {
  home: 'D01',
  chat: 'D02',
  message: 'D02',
  users: 'D03',
  usersfilled: 'D03',
  bookopen: 'D04',
  book: 'D04',
  notification: 'D05',
  bell: 'D05',
  profile: 'D06',
  user: 'D06',
  userround: 'D06',
  grid: 'D07',
  layoutgrid: 'D07',
  calendar: 'D08',
  calendardays: 'D08',
  clipboardlist: 'D09',
  exam: 'D10',
  barchart3: 'D11',
  clipboardcheck: 'D12',
  creditcard: 'D13',
  receipttext: 'D13',
  document: 'D14',
  file: 'D14',
  filetext: 'D14',
  scrolltext: 'D14',
  pickup: 'D15',
  download: 'D16',
  folder: 'D17',
  layers: 'D17',
  trendingup: 'D18',
  setting: 'D19',
  settings: 'D19',
  search: 'D20',
  megaphone: 'D21',
  camera: 'D22',
  image: 'D23',
  imageplus: 'D23',
  photo: 'D23',
  paperclip: 'D24',
  send: 'D25',
  paper: 'D25',
  share: 'D26',
  share2: 'D26',
  scan: 'D27',
  upload: 'D28',
  cloudupload: 'D84',
  repeat: 'D30',
  rotate3d: 'D30',
  school: 'D31',
  globe: 'D31',
  bus: 'D32',
  alerttriangle: 'D33',
  clock: 'D34',
  timesquare: 'D34',
  check: 'D35',
  chevronright: 'D36',
  arrowright: 'D36',
  chevrondown: 'D37',
  chevronleft: 'D38',
  arrowleft: 'D38',
  back: 'D106',
  close: 'D39',
  x: 'D39',
  circlecheck: 'D40',
  checkcircle: 'D40',
  checkcircle2: 'D40',
  checkpickercircle: 'D40',
  info: 'D41',
  infocircle: 'D41',
  lock: 'D42',
  logout: 'D43',
  harddrive: 'D44',
  smartphone: 'D45',
  edit: 'D46',
  pencil: 'D46',
  location: 'D47',
  mappin: 'D47',
  listchecks: 'D48',
  checksquare: 'D48',
  checksquare2: 'D48',
  refresh: 'D49',
  refreshcw: 'D49',
  warning: 'D50',
  filequestion: 'D51',
  graduationcap: 'D52',
  filex: 'D53',
  shield: 'D54',
  shieldcheck: 'D54',
  eye: 'D55',
  show: 'D55',
  add: 'D56',
  plus: 'D56',
  pluscircle: 'D56',
  eyeoff: 'D57',
  hide: 'D57',
  key: 'D58',
  keyround: 'D58',
  target: 'D59',
  circlex: 'D60',
  circlealert: 'D60',
  wifioff: 'D61',
  award: 'D95',
  qrcode: 'D63',
  delete: 'D64',
  trash: 'D64',
  trash2: 'D64',
  calendarcheck: 'D65',
  chart: 'D66',
  chartbar: 'D66',
  chartcolumn: 'D66',
  star: 'D67',
  starfilled: 'D67',
  heart: 'D67',
  heartfilled: 'D67',
  belloff: 'D68',
  category: 'D69',
  moresquare: 'D69',
  calendarx: 'D70',
  login: 'D71',
  link: 'D72',
  call: 'D73',
  phone: 'D73',
  percent: 'D74',
  shieldoff: 'D75',
  monitor: 'D76',
  badgecheck: 'D77',
  archiverestore: 'D78',
  sparkles: 'D79',
  table: 'D80',
  presentation: 'D81',
  video: 'D82',
  music: 'D83',
  coffee: 'D85',
  zap: 'D86',
  clockalert: 'D87',
  more: 'D88',
  ellipsis: 'D88',
  morehorizontal: 'D88',
  mail: 'D91',
  inbox: 'D89',
  faceid: 'D90',
  copy: 'D92',
  moon: 'D93',
  usercheck: 'D94',
  text: 'D96',
  bold: 'D97',
  italic: 'D98',
  heading: 'D99',
  list: 'D100',
  code: 'D101',
  markdown: 'D102',
  arrowupdown: 'D103',
  arrowleftright: 'D103',
  dooropen: 'D104',
  externallink: 'D105',
  history: 'D107',
  shieldalert: 'D108',
  laptop: 'D109',
  activity: 'D110',
  checkcheck: 'D111',
  languages: 'D112',
  sun: 'D113',
  loader: 'D114',
  loader2: 'D114',
  filter: 'D115',
  handshake: 'D116',
  adduser: 'D117',
  userplus: 'D117',
  pin: 'D118',
  trophy: 'D119',
  partypopper: 'D120',
  flame: 'D121',
  building: 'D122',
  building2: 'D122',
  fingerprint: 'D123',
  people: 'D03',
  learning: 'D04',
  notifications: 'D05',
  classes: 'D07',
  schedule: 'D08',
  homework: 'D09',
  exams: 'D10',
  scores: 'D11',
  attendance: 'D12',
  payments: 'D13',
  documents: 'D14',
  pickuppass: 'D15',
  downloads: 'D16',
  storage: 'D17',
  learningprogress: 'D18',
  announcements: 'D21',
  photos: 'D23',
  attachments: 'D24',
  sendmessage: 'D25',
  scanpass: 'D27',
  offlinelessons: 'D29',
  sync: 'D30',
  schoolbranch: 'D31',
  schooltransport: 'D32',
  alert: 'D33',
  time: 'D34',
  next: 'D36',
  expand: 'D37',
  previous: 'D38',
  confirmed: 'D40',
  information: 'D41',
  signout: 'D43',
  storageusage: 'D44',
  device: 'D45',
  checklist: 'D48',
  unknowndocument: 'D51',
  graduation: 'D52',
  documenterror: 'D53',
  protected: 'D54',
  accesskey: 'D58',
  goal: 'D59',
  errorstatus: 'D60',
  offline: 'D61',
  certificate: 'D62',
  scheduled: 'D65',
  analytics: 'D66',
  favorite: 'D67',
  mutednotifications: 'D68',
  cancelledschedule: 'D70',
  signin: 'D71',
  percentage: 'D74',
  protectionoff: 'D75',
  desktop: 'D76',
  verified: 'D77',
  restorearchive: 'D78',
  highlights: 'D79',
  break: 'D85',
  quickaction: 'D86',
  timealert: 'D87',
  faceverification: 'D90',
  email: 'D91',
  darkmode: 'D93',
  verifiedperson: 'D94',
  switch: 'D103',
  opendoor: 'D104',
  openexternally: 'D105',
  protectionalert: 'D108',
  readreceipt: 'D111',
  lightmode: 'D113',
  loading: 'D114',
  parentteacher: 'D116',
  addperson: 'D117',
  celebration: 'D120',
  streak: 'D121',
  areachart: 'D66',
  barcharthorizontal: 'D66',
  calendarcog: 'D08',
  calendarrange: 'D08',
  booka: 'D04',
  bookicon: 'D04',
  filepenline: 'D14',
  gauge: 'D66',
  chevronsupdown: 'D103',
  panelstopleft: 'D69',
  wallet: 'D13',
  receipt: 'D13',
  rotateccw: 'D49',
  calculator: 'D13',
  barchart: 'D66',
  calendarcheck2: 'D65',
  messagesquare: 'D02',
  messagecircle: 'D02',
  helpcircle: 'D41',
};
export const iconCatalogVersion = '1.0.0';
